<template>
  <div>
    <!-- Error flash message -->
    <div class="alert alert-danger" role="alert" v-if="error">
      {{ error.message }}
    </div>

    <div class="alert alert-success" v-if="success">
        {{ success }}
    </div>

    <form class="needs-validation"
      method="POST"
      autocomplete="off"
      @submit.prevent="requestResetPassword">

      <div class="form-group">
        <label for="password">
          Senha
        </label>

        <input type="password"
          :class="{ 'form-control': true, 'is-invalid': passwordError }"
          id="password"
          name="password"
          v-model="password"
          placeholder="Insira sua nova senha"
          required>
      </div>

      <div class="form-group">
        <label for="confirm-password">
          Confirmar senha
        </label>

        <input type="password"
          :class="{ 'form-control': true, 'is-invalid': passwordError }"
          id="confirm-password"
          name="confirm-password"
          v-model="confirmPassword"
          placeholder="Confirme sua nova senha"
          required>
      </div>

      <button type="submit" :disabled="processing" class="btn btn-primary btn-block btn-flat">
        Alterar Senha
      </button>

      <div class="form-group text-center auth-link">
        <router-link :to="{ name: 'auth.login' }">
          <small>
            Voltar para o Login
          </small>
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { get } from 'lodash'
  import { decode } from 'he'
  import { requestResetPassword } from '@/services/auth'

  export default {
    data () {
      return {
        processing: false,
        password: '',
        confirmPassword: '',
        token: '',
        email: '',
        success: ''
      }
    },

    computed: {
      ...mapGetters({
        error: 'errors/getFirstGlobal',
        fieldError: 'errors/getFirstGlobalError'
      }),

      passwordError () { return this.fieldError('password') }
    },

    methods: {
      ...mapActions({
        pushError: 'errors/pushGlobalError',
        clearError: 'errors/clearGlobalErrors'
      }),

      requestPasswordChange () {
        const self = this

        self.processing = true
        self.clearError()
      },

      requestResetPassword () {
        const self = this

        self.processing = true
        self.clearError()

        self.token = self.$route.query.token
        self.email = self.$route.query.email

        requestResetPassword({
          email: self.email,
          token: self.token,
          password: self.password,
          password_confirmation: self.confirmPassword
        })
          .then((res) => {
            self.processing = false
            if (get(res.headers, 'x-message-level') === 'success') {
              self.success = decode(get(res.headers, 'x-message-content'))
            }

            self.password = ''
            self.confirmPassword = ''

            setTimeout(() => {
              window.location.href = '/'
            }, 5000)
          })
          .catch((e) => {
            self.processing = false
            if (e.response) {
              self.pushError([e.response.data])
            }
          })
      }
    }
  }
</script>

<style lang="sass" scoped>
  form
    font-weight: normal;
    margin-top: 50px;

    label
      color: #5a6779;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;

    input
      height: 55px;
      border: 1px solid #ccc;

    .btn
      margin: 30px 0px 20px;
      height: 55px;
      font-weight: bold;
      font-size: 14px;
      text-transform: uppercase;

    .auth-link

      small
        font-weight: 600;
        font-size: 12px;
        color: #5a6779;
        transition: 500ms linear;

        &:hover

          color: #000;

      ::placeholder

          color: #A3A3A3;

</style>



// WEBPACK FOOTER //
// src/components/pages/auth/ChangePassword.vue